export default __webpack_public_path__ + "static/media/citizenmview.e4666415.jpeg";